
import { MutationTypes } from "../store/mutation-types";
import { Options, Vue } from "vue-class-component";
import * as data from "../data/data.json";
import { useStore } from "../store";

@Options({
  props: {
    selectItems: Array,
    title: String,
  },
  data() {
    return {
      arrow: "up",
    };
  },
  methods: {
    onClick(item: string) {
      const path = this.store.state.selectFilters;
      if (this.title.includes("Program")) {
        const chosenProgramId: string = data.data.programs
          .filter((program: { name: string }) => program.name === item)
          .map((program: { _id: string }) => program._id)[0];
        return (
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: chosenProgramId,
            guestType: path.guestType,
            tag: path.tag,
          }),
          this.showMenu()
        );
      } else {
        return (
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: path.programId,
            guestType: item,
            tag: path.tag,
          }),
          this.showMenu()
        );
      }
    },
    // set selected choice as display title
    titleChoice() {
      const path = this.store.state.selectFilters;
      const programName = data.data.programs.filter(
        (program) => program._id === path.programId
      )[0]?.name;
      return this.title.includes("Type") && path.guestType != ""
        ? path.guestType
        : this.title.includes("Program") && path.programId != ""
        ? programName
        : this.title;
    },
    // menu toggle
    showMenu() {
      const path = this.store.state.selectWindow;
      if (!path.open) {
        return (
          this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
            open: true,
            title: this.title,
          }),
          (this.arrow = "down")
        );
      }
      if (path.open && path.title === this.title) {
        return this.hideMenu();
      }
    },
    hideMenu() {
      return (
        this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
          open: false,
          title: this.title,
        }),
        (this.arrow = "up")
      );
    },
    // reset the select values in the state
    clear() {
      const path = this.store.state.selectFilters;
      if (path.programId != "" && this.title.includes("Program")) {
        return (
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: "",
            guestType: path.guestType,
            tag: path.tag,
          }),
          (this.arrow = "up")
        );
      }
      if (path.guestType != "" && this.title.includes("Type")) {
        return (
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: path.programId,
            guestType: "",
            tag: path.tag,
          }),
          this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
            open: false,
            title: this.title,
          }),
          (this.arrow = "up")
        );
      }
    },
  },
})
export default class Select extends Vue {
  store = useStore();
  selectItems!: [string];
  title!: string;
  arrow: string = "up";
}
